import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { palette } from 'c1ui/theme/palette'
import { Check, Minus } from 'lucide-react'

export const C1CheckboxTheme: Components<Theme>['MuiCheckbox'] = {
    defaultProps: {
        icon: (
            <svg
                viewBox="0 0 26 26"
            >
                <rect
                    x="1"
                    y="1"
                    width="24"
                    height="24"
                    rx="4"
                    fill={palette.common.white}
                    stroke={palette.grey[300]}
                    strokeWidth="1.25"
                />
            </svg>
        ),
        checkedIcon: (
            <svg
                viewBox="0 0 26 26"
            >
                <rect
                    x="1"
                    y="1"
                    width="24"
                    height="24"
                    rx="4"
                    fill={palette.primary.main}
                />
                <Check
                    x="4"
                    y="4"
                    width="18"
                    height="18"
                    color={palette.common.white}
                    strokeWidth="2.5"
                />
            </svg>
        ),
        indeterminateIcon: (
            <svg
                viewBox="0 0 26 26"
            >
                <rect
                    x="1"
                    y="1"
                    width="24"
                    height="24"
                    rx="4"
                    fill={palette.primary.main}
                />
                <Minus
                    x="4"
                    y="4"
                    width="18"
                    height="18"
                    color={palette.common.white}
                    strokeWidth="2.5"
                />
            </svg>
        ),
    },
    styleOverrides: {
        root: ({ theme }) =>
            theme.unstable_sx({
                marginX: 1,
                borderRadius: C1BorderRadius.large,
                width: '36px',
                height: '36px',
                svg: {
                    width: '18px',
                    height: '18px',
                },
                '&:hover': {
                    backgroundColor: 'primary.extraLight',
                },
                '&:not(.Mui-checked):hover svg rect': {
                    stroke: palette.primary.dark,
                    fill: 'none',
                },
                '&.Mui-focusVisible': {
                    outline: `2px solid ${palette.primary.main}`,
                    outlineOffset: '1px',
                    backgroundColor: 'primary.extraLight',
                },
                '&.Mui-focusVisible svg rect': {
                    stroke: palette.primary.dark,
                },
                '&.Mui-disabled': {
                    cursor: 'not-allowed',
                },
                '&.Mui-disabled svg rect': {
                    fill: palette.grey[200],
                    stroke: 'transparent',
                },
                '&.Mui-disabled.Mui-checked svg rect': {
                    fill: palette.grey[200],
                },
                '&.Mui-disabled.Mui-checked svg .lucide': {
                    color: palette.grey[400],
                },
            }),
        sizeSmall: {
            width: 18,
            height: 18,
            padding: 0,
            marginRight: '6px',
        },
    },
}
